const mutations = {
  setBranchSchemeList(state, payload) {
    state.branchSchemeList = payload;
  },
  setBranchScheme(state, payload) {
    state.branchScheme = payload;
  },
  setBranchSchemeDetail(state, payload) {
    state.branchSchemeDetail = payload;
  },
  setLinesGridData(state, payload) {
    Object.keys(payload).forEach((key) => {
      state.linesGridData[key] = payload[key];
    });
  },
  setBranchSchemeLinesList(state, payload) {
    state.branchSchemeLinesList = payload;
  },


  };
  
  export default mutations;